module.exports = __webpack_public_path__ + "img/mega_5.fbd0a645.png";